import { ClientApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { OrganizationClientsCount } from '../../../commonTypes/client.types';
import { useTranslation } from '../../useTranslation';

const useHttpGetClientsCountOnMount = (from: string, to: string) => {
    const { t } = useTranslation('newNotifications');
    const clientApi: ClientApi = useContainer(ClientApi);
    const [data, setData] = useState<OrganizationClientsCount>({ countClients: 0, createdAtCount: 0 });
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        const { exec, abort } = clientApi.getOrganizationClientsCount({
            query: { from, to },
            onSuccess: res => setData(res.body),
            onError: _ => toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setReady(true),
        });
        exec();
        return abort;
    }, [clientApi]);

    return { data, isReady };
};

export default useHttpGetClientsCountOnMount;
